// EXTERNAL
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
// LIBS
import { analytics_record } from "../../../../libs/amplify";
// CONTEXTS
import { useUserState } from "../../../../contexts/user.context";
// COMPONENTS
import { PCNPSForm } from "@picnicmedia/masanatemples123";
// ASSETS
import "../assets/style.css";
// TYPES
interface NPSProps {
  question: string;
  submitMessage: string;
}

export function NPS({ question, submitMessage }: NPSProps) {
  const user = useUserState();
  const [npsTriggered, setNpsTriggered] = useState(false);
  useEffect(() => {
    /**
     * This will need refactoring if we ever want to reuse this feature.
     */
    let creativesBuilt = localStorage.getItem("creativesBuilt");
    let npsFormSubmitted = localStorage.getItem("npsFormSubmitted");
    /**
     * If user has submitted form before, npsFormSubmitted will be set to "ISOString" formatted date.
     * Don't show users the form again, if they've already submitted it.
     */
    if (npsFormSubmitted !== null) return;
    if (creativesBuilt !== undefined) {
      const creativesBuiltCount = new Set(JSON.parse(creativesBuilt!)).size;
      /**
       * Check unique builds value is greater than 10.
       */
      if (creativesBuiltCount > 3) {
        setNpsTriggered(true);
      }
    }
  }, []);

  function handleSubmit(score: number) {
    /**
     * Send user submits to the Analytics sheet.
     */
    analytics_record({
      name: "nps_submit",
      attributes: {
        id: user.id,
        teamId: user.teamId,
        teamName: user.teamName,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        score: score,
        question: question,
      },
    });
    /**
     * Remove 'creativesBuilt' item from localStorage once a user has seen the form.
     * Potential downside in future is that if a user resets their browser cache, they will see the form again after 10 creative builds.
     * Set 'npsFormSubmitted' item to current date in localstorage - date is not important, but could be used in future to work out if we want to show the form again, at the moment it's just important that a non-null value exists.
     */
    localStorage.removeItem("creativesBuilt");
    localStorage.setItem("npsFormSubmitted", new Date().toISOString());
    /**
     * Remove NPS form the DOC after 2s after user has submitted a score.
     */
    setTimeout(() => {
      setNpsTriggered(false);
    }, 2000);
  }

  function handleDismiss() {
    /**
     * Add NPSSlideOut class to form to trigger slide out animation.
     */
    setNpsTriggered(false);
    /**
     * Send user dismiss events to the Analytics sheet.
     */
    analytics_record({
      name: "nps_dismiss",
      attributes: {
        userId: user.id,
        teamId: user.teamId,
        teamName: user.teamName,
        userEmail: user.email,
        score: "",
        question: question,
      },
    });
  }

  return (
    <div id="feature-nps">
      {npsTriggered
        ? createPortal(
            <div className={`${npsTriggered ? "NPSSlideIn" : ""} nps-container fixed w-100`} style={{ bottom: 0, zIndex: 1200 }}>
              <PCNPSForm handleDismiss={() => handleDismiss()} handleSubmit={(score) => handleSubmit(score)} question={question} submitMessage={submitMessage} />
            </div>,
            document.body,
          )
        : null}
    </div>
  );
}
